export const medicationsTranslations = {
  fr: {
    title: "Médicaments",
    search: "Rechercher",
    analyze: "Analyser",
    analyzing: "Analyse en cours...",
    placeholder: "Nom du médicament (ex: Doliprane, Aspirine...)",
    newSearch: "Nouvelle recherche",
    recentSearches: "Recherches récentes",
    analysisComplete: "Analyse terminée",
    flashcardsCreated: "Flashcards créées avec succès",
    hero: {
      title: "Analyse de Médicaments",
      description: "Recherchez des informations détaillées sur les médicaments et leurs propriétés",
      stats: "Plus de 500 médicaments analysés"
    },
    emptyState: {
      title: "Commencez votre recherche",
      description: "Entrez le nom d'un médicament pour obtenir une analyse complète",
      buttonSearch: "Rechercher",
      buttonExamples: "Voir les exemples"
    },
    examples: {
      title: "Exemples gratuits",
      subtitle: "Cliquez pour charger un exemple"
    },
    analysis: {
      title: "Analyse - {{medicationName}}",
      forms: "Formes disponibles",
      lastUpdate: "Dernière mise à jour",
      indications: "Indications",
      posology: "Posologies",
      contraindications: "Contre-indications",
      precautions: "Précautions",
      majorInteractions: "Interactions majeures",
      sideEffects: "Effets indésirables",
      pregnancyBreastfeeding: "Grossesse et allaitement",
      pharmacokinetics: "Pharmacocinétique",
      surveillance: "Surveillance",
      overdose: "Surdosage",
      fullRcp: "RCP complet"
    },
    createFlashcards: "Créer des flashcards",
    creatingFlashcards: "Création en cours...",
    infoCards: {
      search: {
        title: "Recherche de médicaments",
        description: "Recherchez des informations détaillées sur les médicaments et leurs propriétés"
      },
      analysis: {
        title: "Analyse détaillée",
        description: "Obtenez des analyses complètes incluant posologie, effets secondaires et interactions"
      },
      flashcards: {
        title: "Création de flashcards",
        description: "Générez automatiquement des flashcards pour mémoriser les informations importantes"
      }
    },
    loading: {
      searching: "Recherche en cours…",
      analyzing: "Analyse en cours…",
      checkingInteractions: "Vérification des interactions…",
      generatingReport: "Génération du rapport…",
    },
    errors: {
      searchRequired: "Veuillez saisir un nom de médicament",
      analysisError: "Erreur lors de l'analyse du médicament",
      flashcardsError: "Erreur lors de la création des flashcards",
      incompleteCache: "Données incomplètes en cache: régénération…"
    },
    analysisImpossible: "Analyse impossible",
    analysisImpossibleDesc: "Nous n'avons pas pu analyser « {{name}} ». Vérifiez l'orthographe ou essayez un autre nom.",
    retry: "Réessayer",
    copied: "Copié !",
    linkCopied: "Lien copié !",
    sections: {
      contraindications: 'CI',
      interactions: 'Interactions',
      sideEffects: 'Effets ind.',
      pregnancy: 'Grossesse',
      pharmacokinetics: 'PK',
      surveillance: 'Surveillance',
      overdose: 'Surdosage',
    },
    features: {
      contraindications: 'Contre-indications',
      interactions: 'Interactions médicamenteuses',
      posology: 'Posologies',
      pregnancy: 'Grossesse & allaitement',
      sideEffects: 'Effets indésirables',
      surveillance: 'Surveillance',
    },
  },
  en: {
    title: "Medications",
    search: "Search",
    analyze: "Analyze",
    analyzing: "Analyzing...",
    placeholder: "Medication name (e.g: Paracetamol, Aspirin...)",
    newSearch: "New search",
    recentSearches: "Recent searches",
    analysisComplete: "Analysis completed",
    flashcardsCreated: "Flashcards created successfully",
    hero: {
      title: "Medication Analysis",
      description: "Search for detailed information about medications and their properties",
      stats: "Over 500 medications analyzed"
    },
    emptyState: {
      title: "Start your search",
      description: "Enter a medication name to get a comprehensive analysis",
      buttonSearch: "Search",
      buttonExamples: "View examples"
    },
    examples: {
      title: "Free examples",
      subtitle: "Click to load an example"
    },
    analysis: {
      title: "Analysis - {{medicationName}}",
      forms: "Available forms",
      lastUpdate: "Last update",
      indications: "Indications",
      posology: "Posology",
      contraindications: "Contraindications",
      precautions: "Precautions",
      majorInteractions: "Major interactions",
      sideEffects: "Side effects",
      pregnancyBreastfeeding: "Pregnancy and breastfeeding",
      pharmacokinetics: "Pharmacokinetics",
      surveillance: "Surveillance",
      overdose: "Overdose",
      fullRcp: "Full RCP"
    },
    createFlashcards: "Create flashcards",
    creatingFlashcards: "Creating...",
    infoCards: {
      search: {
        title: "Medication search",
        description: "Search for detailed information about medications and their properties"
      },
      analysis: {
        title: "Detailed analysis",
        description: "Get comprehensive analyses including dosage, side effects and interactions"
      },
      flashcards: {
        title: "Flashcard creation",
        description: "Automatically generate flashcards to memorize important information"
      }
    },
    loading: {
      searching: "Searching…",
      analyzing: "Analyzing…",
      checkingInteractions: "Checking interactions…",
      generatingReport: "Generating report…",
    },
    errors: {
      searchRequired: "Please enter a medication name",
      analysisError: "Error analyzing medication",
      flashcardsError: "Error creating flashcards",
      incompleteCache: "Incomplete cached data: regenerating…"
    },
    analysisImpossible: "Analysis impossible",
    analysisImpossibleDesc: "We could not analyze \"{{name}}\". Check the spelling or try another name.",
    retry: "Retry",
    copied: "Copied!",
    linkCopied: "Link copied!",
    sections: {
      contraindications: 'CI',
      interactions: 'Interactions',
      sideEffects: 'Side effects',
      pregnancy: 'Pregnancy',
      pharmacokinetics: 'PK',
      surveillance: 'Monitoring',
      overdose: 'Overdose',
    },
    features: {
      contraindications: 'Contraindications',
      interactions: 'Drug interactions',
      posology: 'Dosage',
      pregnancy: 'Pregnancy & breastfeeding',
      sideEffects: 'Side effects',
      surveillance: 'Monitoring',
    },
  },
  es: {
    title: "Medicamentos",
    search: "Buscar",
    analyze: "Analizar",
    analyzing: "Analizando...",
    placeholder: "Nombre del medicamento (ej: Paracetamol, Aspirina...)",
    newSearch: "Nueva búsqueda",
    recentSearches: "Búsquedas recientes",
    analysisComplete: "Análisis completado",
    flashcardsCreated: "Flashcards creadas exitosamente",
    hero: {
      title: "Análisis de Medicamentos",
      description: "Busca información detallada sobre medicamentos y sus propiedades",
      stats: "Más de 500 medicamentos analizados"
    },
    emptyState: {
      title: "Comienza tu búsqueda",
      description: "Ingresa el nombre de un medicamento para obtener un análisis completo",
      buttonSearch: "Buscar",
      buttonExamples: "Ver ejemplos"
    },
    examples: {
      title: "Ejemplos gratuitos",
      subtitle: "Haz clic para cargar un ejemplo"
    },
    analysis: {
      title: "Análisis - {{medicationName}}",
      forms: "Formas disponibles",
      lastUpdate: "Última actualización",
      indications: "Indicaciones",
      posology: "Posología",
      contraindications: "Contraindicaciones",
      precautions: "Precauciones",
      majorInteractions: "Interacciones mayores",
      sideEffects: "Efectos secundarios",
      pregnancyBreastfeeding: "Embarazo y lactancia",
      pharmacokinetics: "Farmacocinética",
      surveillance: "Vigilancia",
      overdose: "Sobredosis",
      fullRcp: "RCP completo"
    },
    createFlashcards: "Crear flashcards",
    creatingFlashcards: "Creando...",
    infoCards: {
      search: {
        title: "Búsqueda de medicamentos",
        description: "Busca información detallada sobre medicamentos y sus propiedades"
      },
      analysis: {
        title: "Análisis detallado",
        description: "Obtén análisis completos incluyendo dosis, efectos secundarios e interacciones"
      },
      flashcards: {
        title: "Creación de flashcards",
        description: "Genera automáticamente flashcards para memorizar información importante"
      }
    },
    loading: {
      searching: "Buscando…",
      analyzing: "Analizando…",
      checkingInteractions: "Verificando interacciones…",
      generatingReport: "Generando informe…",
    },
    errors: {
      searchRequired: "Por favor ingresa un nombre de medicamento",
      analysisError: "Error al analizar el medicamento",
      flashcardsError: "Error al crear las flashcards",
      incompleteCache: "Datos incompletos en caché: regenerando…"
    },
    analysisImpossible: "Análisis imposible",
    analysisImpossibleDesc: "No pudimos analizar «{{name}}». Verifica la ortografía o prueba con otro nombre.",
    retry: "Reintentar",
    copied: "¡Copiado!",
    linkCopied: "¡Enlace copiado!",
    sections: {
      contraindications: 'CI',
      interactions: 'Interacciones',
      sideEffects: 'Efectos adv.',
      pregnancy: 'Embarazo',
      pharmacokinetics: 'PK',
      surveillance: 'Vigilancia',
      overdose: 'Sobredosis',
    },
    features: {
      contraindications: 'Contraindicaciones',
      interactions: 'Interacciones medicamentosas',
      posology: 'Posología',
      pregnancy: 'Embarazo y lactancia',
      sideEffects: 'Efectos secundarios',
      surveillance: 'Vigilancia',
    },
  }
};